/**
 * Product Form Components
 *
 */
class PurchaseForm extends HTMLElement {
  constructor() {
    super();

    this.qtyBtns = this.querySelectorAll("[data-qty-btn]");
    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
    );

    this.cartAPIThreads = [];

    this.productsDiv = this.querySelectorAll("[data-product-row]");
    this.summaryDiv = this.querySelector("[data-summaryList]");
    this.cartIconDesktop = document.querySelector("#cart-icon-desktop");
    this.cartIconMobile = document.querySelector("#cart-icon-mobile");

    // Remove old items from cart
    this.removeOldItems();

    this.freeShippingEligible = false;
    this.checkFreeShippingEligible();

    // Debounce setup
    this.updateDebounceTimer = null;

    this.fetchCart(() => {
      this.checkFreeGifts();
    });
  }

  initiateOrderSummary(forceReload) {
    if (typeof forceReload === 'undefined') {
      forceReload = true;
    }

    console.log('--- initiateOrderSummary() ---');
    this.arraySummary = [];

    this.refreshOrderSummaryData();
    this.displayOrderSummary();
    this.updateFreeShippingProgress();
    this.updateCartCount();

    if (forceReload) {
      setTimeout(() => {
        this.fetchCart();
        this.initiateOrderSummary(false);

        // Update data-cartid for each row in the table
        this.updateTableRows();
      }, 500);
    }

    console.log("+++++++++++++++hereis promo+++++++++++++++++");
    console.log('---- applypromo: ' + applypromo);
     if(applypromo){
       $('[data-add-main-cart]').addClass('disabled');
        setTimeout(function() {

        const discountvariantIds = discountedProducts.map(product => product.variants[0].id);

        const staticIds = discountvariantIds; // add your target variant IDs here
          let totalItemDiscountAmount = 0; // To store total discount for matching items

          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const discounts = cart.discount_codes;
              console.log(cart);
              if (discounts.length > 0) {
                discounts.forEach(discount => {
                  if (discount.applicable) {
                    $(".discountapplied").text(discountapplied);
                    $(".discountfield").show();
                    $('.discount_total').removeAttr('style');
                    const totalAmount = Shopify.formatMoney(
                      cart.total_price,
                      window.globalVariables?.money_format || '₹{{amount}}'
                    );

                    console.log(`✅ Discount "${discount.code}" is applied and valid.`);

                    // Loop through cart items
                    cart.items.forEach(item => {
                      if (staticIds.includes(item.variant_id)) {
                        if (item.discounts && item.discounts.length > 0) {
                          item.discounts.forEach(d => {
                            totalItemDiscountAmount += d.amount;

                            const formattedAmount = Shopify.formatMoney(
                              d.amount,
                              window.globalVariables?.money_format || '₹{{amount}}'
                            );

                            console.log(`🧾 Item "${item.title}" got discount "${d.title}" of ${formattedAmount}`);
                          });
                        }
                      }
                    });
                    $('[data-add-main-cart]').removeClass('disabled');
                  } else {
                    $(".discountfield").hide();
                    $('.discount_total').attr('style', 'display: none !important');

                    $('[data-add-main-cart]').removeClass('disabled');
                    console.log(`⚠️ Discount "${discount.code}" is applied but NOT applicable.`);
                  }
                });
              } else {
                $(".discountfield").hide();
                $('.discount_total').attr('style', 'display: none !important');
                $('[data-add-main-cart]').removeClass('disabled');
                console.log('❌ No discount code applied.');
              }

              // ✅ Use total discount amount outside the loop
              if (totalItemDiscountAmount > 0) {
                  const formattedDiscount = Shopify.formatMoney(
                      totalItemDiscountAmount,
                      window.globalVariables?.money_format || '₹{{amount}}'
                    );

                    // Step 1: Get the current total from the DOM (as text), remove currency and commas
                    let originalTotalText = $(".estimated-total-price .money").text().replace(/[^0-9.]/g, '');
                    let originalTotal = parseFloat(originalTotalText);

                    // Step 2: Convert Shopify's cents-based discount into decimal
                    let discountAmount = totalItemDiscountAmount / 100;

                    // Step 3: Calculate new total
                    let newTotal = originalTotal - discountAmount;

                    // Step 4: Format new total using Shopify's formatter
                    const formattedNewTotal = Shopify.formatMoney(
                      Math.round(newTotal * 100), // convert to cents
                      window.globalVariables?.money_format || '₹{{amount}}'
                    );



                    // Step 5: Update the UI
                    console.log(`💰 Total discount on specific items: ${formattedDiscount}`);
                    $('[data-add-main-cart]').removeClass('disabled');
                    $(".discount_total .money").text("-" + formattedDiscount);
                    $(".estimated-total-price .money").text(formattedNewTotal);
                }


            })
            .catch(err => {
              console.error('Error checking cart/discounts:', err);
            });

      }, 2000);
    }
  }

  refreshOrderSummaryData() {
    this.productsDiv.forEach((productDiv) => {
      const collection = productDiv.getAttribute("data-collection");
      const tags = productDiv.getAttribute("data-tags");
      const productHandle = productDiv.getAttribute("data-product-handle");
      const productTitle = productDiv.getAttribute("data-producttitle");
      const productOrderPack = productDiv.getAttribute("data-productOrderPack");
      const sku = productDiv.dataset.sku;
      const price = productDiv.dataset.price;
      const variantId = productDiv.getAttribute("data-variantid");

      // We should not show FREE GIFT line item in the main list of ORDER SUMMARY
      if (this.lineItems) {
        if (this.lineItems.some(item => item.id == variantId && item.properties?.free_gift == true)) {
          return;
        }
      }

      const quantity = parseInt(
        productDiv.querySelector(".quantity-box [data-qty-input]")?.value || 0
      );

      if (quantity !== 0) {
        var productImg = productDiv.querySelector(".product-image")
          ? productDiv.querySelector(".product-image").getAttribute("src")
          : "";
        if (productImg == "") {
          if (productOrderPack.indexOf("Controller") != -1) {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-controller.jpg?v=1706003897";
          } else if (productOrderPack.indexOf("Charger") != -1) {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-wall.jpg?v=1706003897";
          } else if (productOrderPack.indexOf("Adapter") != -1) {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-adapters.jpg?v=1706003897";
          } else if (productOrderPack.indexOf("Eyewear") != -1) {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-accessories.jpg?v=1706003897";
          } else if (productOrderPack.indexOf("Strap") != -1) {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-straps.jpg?v=1706003897";
          } else {
            productImg =
              "https://cdn.shopify.com/s/files/1/0693/1811/5606/files/part-straps.jpg?v=1706003897";
          }
        }
        const summaryItem = {
          collection,
          tags,
          productHandle,
          productTitle,
          productOrderPack,
          sku,
          price,
          quantity,
          variantId,
          productImg: productImg,
          lineItem: this.lineItems?.filter(item => item.id == variantId)[0],
          isFreeGift: false
        };
        this.arraySummary.push(summaryItem);
      }
    });

    for (let index in this.lineItems) {
      const item = this.lineItems[index];
      if (item.properties?.free_gift) {
        // Free Gift
        this.arraySummary.push({
          collection: '',
          productHandle: item.handle,
          productTitle: item.product_title,
          productOrderPack: '',
          sku: item.sku,
          price: item.price,
          quantity: item.quantity,
          variantId: item.id,
          productImg: item.image,
          lineItem: item,
          isFreeGift: true
        });
      }
    }

    console.log(this.arraySummary);
  }

  isGwpEligible() {
    if ( !this.lineItems ) {
      return false;
    }

    // Sum up the eligible product quantities in the cart. Compare minimum qty which is configured in the Theme Settings
    const qtyX = this.lineItems.reduce((sum, lineitem) => sum + (window.theme.giftWithPurchase.eligibleProducts.includes("|" + lineitem.handle + "|") ? lineitem.quantity : 0), 0);
    const isGwpEligible = (qtyX >= window.theme.giftWithPurchase.minQtyX);
    console.log(`*** ${isGwpEligible ? 'Eligible' : 'NOT Eligible'} ***`);

    return isGwpEligible;
  }

  displayOrderSummary() {
    this.summaryDiv.innerHTML = "";
    let summaryHTML = "";

    /* Full devices */
    const fullSizeDevicesNumber = this.arraySummary.reduce((sum, product) => {
      return product.tags.includes("full-size-device")
        ? sum + product.quantity
        : sum;
    }, 0);

    const fullSizeDevicesInput = document.getElementById("js-full-size-devices");
    const giftBlock = document.querySelector(".js-welcome-gift-block");

    if (fullSizeDevicesInput) {
      const isEligible = fullSizeDevicesNumber >= 5;

      fullSizeDevicesInput.value = isEligible ? "true" : "false";
      giftBlock.style.display = isEligible ? "block" : "none";
    }

    const totalLEDdevices = this.arraySummary.reduce((sum, product) => {
      if (product.collection == "purchase-order-devices") {
        return sum + product.quantity;
      } else {
        return sum;
      }
    }, 0);

    const totalMiniLEDdevices = this.arraySummary.reduce((sum, product) => {
      if (product.collection == "mini-led-devices") {
        return sum + product.quantity;
      } else {
        return sum;
      }
    }, 0);

    const totalHydrogeldevices = this.arraySummary.reduce((sum, product) => {
      if (
        product.collection == "purchase-order-hydrogel" ||
        product.collection == "skin-care"
      ) {
        return sum + product.quantity;
      } else {
        return sum;
      }
    }, 0);

    const totalRetailMaterials = this.arraySummary.reduce((sum, product) => {
      if (product.collection == "retail-support-material") {
        return sum + product.quantity;
      } else {
        return sum;
      }
    }, 0);

    const isHydrogelOnly =
      (totalHydrogeldevices > 0 || totalMiniLEDdevices > 0 || totalRetailMaterials > 0) &&
      totalLEDdevices === 0;
    const isCartEmpty =
      totalLEDdevices + totalHydrogeldevices + totalMiniLEDdevices + totalRetailMaterials === 0;

    if (!isCartEmpty) {
      let estimatedTotal = 0;


      if (window.theme.giftWithPurchase.mode == 'manual') {
        // If there is any eligible product, render GWP blocks one by one.
        // -- Each block should have: Image, Title, FREE GIFT badge, SELECTED badge (in the right corner), SELECT button
        if (this.isGwpEligible()) {
          summaryHTML += '<div class="manual-free-gift border-bottom p-2">';
          summaryHTML += '<div class="manual-free-gift-disclaimer">You’ve qualified for a FREE gift (Choose 1)</div>';

          window.theme.giftWithPurchase.giftProducts.forEach(giftProduct => {
            // Check if in the cart already
            let addedToCart = this.lineItems.some(item => item.id == giftProduct.variantId);

            summaryHTML += `<div class="order-summary-item order-summary-free-gift p-2${addedToCart ? ' is-selected' : ''}">
                <div class="row align-items-center">
                  <div class="col-2" style="padding: 0;">
                    <img src="${giftProduct.image}" alt="${giftProduct.title}" class="img-fluid">
                  </div>
                  <div class="col-10 col-gift-info">
                    <div class="free-gift-title fw-medium">${giftProduct.title}</div>
                    <button data-add-gift data-variant-id="${giftProduct.variantId}" type="button" class="btn btn-primary btn-block mt-1 btn-add-gift"${addedToCart ? ' disabled' : ''}>Select As A Gift</button>
                  </div>
                </div>
                <span data-remove-gift data-variant-id="${giftProduct.variantId}" class="selected-mark" title="Click to remove">
                  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.730962" y="1.23096" width="12.5381" height="12.5381" rx="6.26903" stroke="white" stroke-width="1.46192"></rect><path d="M5.83333 10.0663L3.5 7.73301L4.31667 6.91634L5.83333 8.43301L9.68333 4.58301L10.5 5.39967L5.83333 10.0663Z" fill="white"></path></svg>
                  <span class="selected-mark-label">Selected</span>
                </span>
              </div>`;
          });

          summaryHTML += '</div>';
        }
      }

      this.arraySummary.forEach((summary) => {
        if (window.theme.giftWithPurchase.mode == 'manual' && summary.isFreeGift) {
          return true;
        }

        estimatedTotal += summary.price * summary.quantity;
        let imageHTML = "";
        if (summary.productImg != "") {
          imageHTML += `
                        <div class="col-2">
                            <img src="${summary.productImg}" alt="Square Image" class="img-fluid">
                        </div>
                        `;
        } else {
          imageHTML += `
                        <div class="col-2">
                        </div>
                        `;
        }

        summaryHTML += `<div class="order-summary-item border-bottom d-flex align-items-center p-2" data-variantid="${summary.variantId}">${imageHTML}
                        <div class="col-10" style="margin-left: 6px; font-size: smaller; padding: 0 15px;">

                            <div class="row">
                                <div class="col-10">
                                    <div class="fw-medium">${summary.productTitle}</div>
                                </div>

                                <div class="col-2 mb-1 qty">
                                    <div class="d-flex align-items-center mt-1">
                                        <span class="me-2">${summary.quantity}</span>
                                    </div>
                                </div>
                            </div>`;

        const html_auto_discount_code = (summary.lineItem.discounts.length > 0 && summary.lineItem.discounts[0].title.toLowerCase().includes('% off') ? `<div class="discount-code">${summary.lineItem.discounts[0].title}</div>` : '');

        if ( summary.isFreeGift ) {
          summaryHTML += `<div class="row"><div class="col-9">Free Gift</div></div>`;
        } else {
          summaryHTML += `<div class="row">
                                <div class="col-9">
                                    <span class="me-2">${summary.productOrderPack}</span>
                                    ${html_auto_discount_code}
                                </div>

                                <div class="col-3 mt-1 remove-btn">
                                    <a href="javascript:void(0);" class="text-decoration-underline" title="Remove" aria-label="Remove" data-toggle="tooltip" data-itemremove="" data-index="1" data-placement="left">Remove</a>
                                </div>
                          </div>`;
        }

        summaryHTML += `</div>
                </div>`;
      });


      this.summaryDiv.innerHTML = summaryHTML;

      this.querySelector("[data-Estimated-total-price] h5 span").innerHTML =
        Shopify.formatMoney(
          estimatedTotal,
          window.globalVariables.money_format
        );

      this.querySelector("[data-Estimated-total]").classList.remove("d-none");
      this.querySelector(".message-error").classList.add("d-none");

      this.qtyBtns = this.querySelectorAll("[data-summarylist] [data-qty-btn]");
      this.qtyBtns.forEach((qtyBtn) =>
        qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
      );
    } else {
      this.summaryDiv.innerHTML = "";
      this.querySelector("[data-Estimated-total-price] h5 span").innerHTML = "";
      this.querySelector("[data-Estimated-total]").classList.add("d-none");
      this.querySelector(".message-error").classList.remove("d-none");
    }

    // Update Place Order button and Icons
    if (totalLEDdevices >= MINIMUM_UNITS) {
      this.querySelector("[data-add-main-cart]").classList.remove("disabled");
      // this.querySelector(".order-must-block-1").style.display = "flex";
      document.querySelector(".min-ten").classList.remove("fa-xmark");
      document.querySelector(".min-ten").classList.add("fa-check");
      document.querySelector(".min-ten").style.color = "green";
    } else {
      this.querySelector("[data-add-main-cart]").classList.add("disabled");
      // this.querySelector(".order-must-block-1").style.display = "flex";
      document.querySelector(".min-ten").classList.remove("fa-check");
      document.querySelector(".min-ten").classList.add("fa-xmark");
      document.querySelector(".min-ten").style.color = "#d0021b";
    }

    // Update Hyrdogel Icon and place order
    if (totalLEDdevices > 0 && totalHydrogeldevices > 0) {
      document.querySelector(".hydrogel-added").style.color = "#d0021b";
    } else if (isHydrogelOnly) {
      document.querySelector(".hydrogel-added").style.color = "green";
      // this.querySelector(".order-must-block-1").style.display = "none";
      this.querySelector("[data-add-main-cart]").classList.remove("disabled");
    } else if (isCartEmpty) {
      document.querySelector(".hydrogel-added").style.color = "#d0021b";
      // this.querySelector(".order-must-block-1").style.display = "flex";
      this.querySelector("[data-add-main-cart]").classList.add("disabled");
    } else {
      document.querySelector(".hydrogel-added").style.color = "#d0021b";
    }


    this.removeLinks = this.querySelectorAll("[data-itemremove]");
    this.removeLinks.forEach((removeLink) =>
      removeLink.addEventListener(
        "click",
        this.removeProductFromCart.bind(this)
      )
    );

    this.querySelectorAll("[data-add-gift]").forEach((button) => {
      button.addEventListener("click", this.addGiftEventHandler.bind(this));
    });

    this.querySelectorAll("[data-remove-gift]").forEach((button) => {
      button.addEventListener("click", this.removeGiftEventHandler.bind(this));
    });
  }

  async addGiftEventHandler(event) {
    let element = event.currentTarget;
    let idsToRemove = window.theme.giftWithPurchase.giftProducts.map(product => {
      const freeGiftExists = this.lineItems.some(obj => obj.id == product.variantId);

      if (freeGiftExists && product.variantId != element.dataset.variantId) {
        return product.variantId
      } else {
        return false
      }
    }).filter(id => id != false);

    this.lockFreeGifts();

    // If there is no gifts to remove, should refresh the summary after API call
    await this.addFreeGifts([
      element.dataset.variantId
    ], true);

    // Remove other gifts in case exists
    await this.removeFreeGifts(idsToRemove);

    this.unlockFreeGifts();
  }

  async removeGiftEventHandler(event) {
    let element = event.currentTarget;

    this.lockFreeGifts();
    await this.removeFreeGifts([
      element.dataset.variantId
    ]);
    this.unlockFreeGifts();
  }

  updateFreeShippingProgress() {
    if (this.freeShippingEligible) {
      const totalLEDdevices = this.arraySummary.reduce((sum, product) => {
        if (product.collection == "purchase-order-devices") {
          return sum + product.quantity;
        } else {
          return sum;
        }
      }, 0);

      let devicesFromFreeShip = document.getElementById("devices-from-free-ship");
      if (devicesFromFreeShip) {
        const devicesRemaining = FREE_SHIPPING_THRESHOLD - totalLEDdevices;
        devicesFromFreeShip.innerText = devicesRemaining;
      }

      if (totalLEDdevices <= FREE_SHIPPING_THRESHOLD && totalLEDdevices >= 0) {
        const percentage = totalLEDdevices * (100 / FREE_SHIPPING_THRESHOLD);
        const progressBar = document.getElementById("progress-bar");

        if (progressBar) {
          progressBar.style.display = "block";
          progressBar.style.width = `${percentage}%`;
        }
      }

      const freeShippingInfo = document.getElementById("free-shipping-info");
      const devicesRemainingCounter = document.getElementById("devices-remaining-counter");

      if (totalLEDdevices >= FREE_SHIPPING_THRESHOLD) {
        // User earned free shipping
        if (freeShippingInfo) {
          freeShippingInfo.style.display = "block";
        }

        if (devicesRemainingCounter) {
          devicesRemainingCounter.style.display = "none";
        }

        document.querySelector(".free-shipping").classList.remove("fa-xmark");
        document.querySelector(".free-shipping").classList.add("fa-check");
        document.querySelector(".free-shipping").style.color = "green";
      } else {
        // User has not earned free shipping yet
        if (freeShippingInfo) {
          freeShippingInfo.style.display = "none";
        }

        if (devicesRemainingCounter) {
          devicesRemainingCounter.style.display = "block";
        }

        document.querySelector(".free-shipping").classList.remove("fa-check");
        document.querySelector(".free-shipping").classList.add("fa-xmark");
        document.querySelector(".free-shipping").style.color = "#d0021b";
      }
    } else {
      document.getElementById("free-shipping-progress-bar").innerText =
        "Unfortunately, we are unable to offer free shipping to your location at this time.";

      const orderMustIcon = document.querySelector(".order-must-block-2 .col-1 .order-must-icon");
      orderMustIcon.classList.remove('fa-check');
      orderMustIcon.classList.add('fa-xmark');
      document.querySelector(".order-must-block-2 .col-11").innerHTML =
        "<div class='row'><span class='order-must-text'>Unfortunately, we are unable to offer free shipping to your location at this time.</span></div>";
    }
  }

  updateCartCount() {
    const total = this.arraySummary.reduce((sum, product) => {
      return sum + product.quantity;
    }, 0);

    const cartCountDesktop = this.cartIconDesktop
      ? this.cartIconDesktop.querySelector(".cart-count")
      : null;
    const cartCountMobile = this.cartIconMobile
      ? this.cartIconMobile.querySelector(".cart-count")
      : null;

    if (cartCountDesktop) {
      cartCountDesktop.innerText = total;
    } else if (total > 0 && this.cartIconDesktop) {
      this.cartIconDesktop.querySelector(
        "i"
      ).innerHTML = `<span aria-hidden="true" class="cart-count ms-2 fw-medium font-family-base">${total}</span>`;
    }

    if (cartCountMobile) {
      cartCountMobile.innerText = total;
    } else if (total > 0 && this.cartIconMobile) {
      this.cartIconMobile.querySelector(
        "i"
      ).innerHTML = `<span aria-hidden="true" class="cart-count ms-2 fw-medium font-family-base">${total}</span>`;
    }
  }

  async checkFreeGifts() {
    console.log('++++ checkFreeGifts() ++++');
    // Loop each line item
    if (window.theme.giftWithPurchase.mode == 'auto' && window.theme.giftWithPurchase.eligibleProducts) {
      // Sum up the eligible product quantities in the cart. Compare minimum qty which is configured in the Theme Settings
      if (this.isGwpEligible()) {
        // Add free gift
        let freeGiftIds = [];

        window.theme.giftWithPurchase.giftProducts.forEach(product => {
          const freeGiftExists = this.lineItems.some(obj => obj.id == product.variantId);
          if (!freeGiftExists) {
            freeGiftIds.push(product.variantId);
          }
        });

        if (freeGiftIds.length > 0) {
          await this.addFreeGifts(freeGiftIds);
        } else {
          this.initiateOrderSummary();
        }

      } else {
        // Remove all the free gifts from the cart
        await this.removeAllFreeGifts();
      }
    } else if (window.theme.giftWithPurchase.mode == 'disabled') {
      // Remove all the free gifts from the cart
      await this.removeAllFreeGifts();
    } else {
      // Manual
      if (this.isGwpEligible()) {
        this.initiateOrderSummary();
      } else {
        await this.removeAllFreeGifts();
      }
    }
  }

  lockFreeGifts() {
    document.querySelector('.manual-free-gift').classList.add('pending');
  }

  unlockFreeGifts() {
    document.querySelector('.manual-free-gift').classList.remove('pending');
  }

  async addFreeGifts(variantIds, refreshSummary) {
    if (typeof refreshSummary === 'undefined') {
      refreshSummary = true;
    }

    const items = variantIds.map(id => ({
      id,
      quantity: 1,
      properties: {
        free_gift: true
      }
    }));
    const response = await fetch("/cart/add.js", {
      body: JSON.stringify({ items }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    });

    //const json = await response.json();

    if (refreshSummary) {
      await this.fetchCart();
      this.initiateOrderSummary();
    }
  }


  async removeFreeGifts(variantIds, refreshSummary) {
    if (typeof refreshSummary === 'undefined') {
      refreshSummary = true;
    }

    let updates = {};

    this.lineItems.forEach(lineitem => {
      if (variantIds.some(id => id == lineitem.id)) {
        updates[lineitem.key] = 0;
      }
    });

    if (Object.keys(updates).length == 0) {
      if ( refreshSummary ) {
        this.initiateOrderSummary();
      }
      return;
    }

    const response = await fetch("/cart/update.js", {
      body: JSON.stringify({ updates: updates }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    });

    const json = await response.json();

    if (json.items) {
      this.lineItems = json.items;
      console.log('--- removeFreeGift() ---', this.lineItems);

      // Update table
      this.updateTableRows();
    }

    if ( refreshSummary ) {
      this.initiateOrderSummary();
    }
  }

  async removeAllFreeGifts() {
    if ( !this.lineItems) {
      return;
    }

    let idsToRemove = {};
    this.lineItems.forEach(lineitem => {
      const isFreeGift = window.theme.giftWithPurchase.giftProducts.some(product => product.variantId == lineitem.id);
      if (isFreeGift) {
        idsToRemove[lineitem.key] = 0;

        // Get Variant ID from the line item and update Quantity field in the table if exists.
        let tableRow = document.querySelector(`tr[data-variantid="${lineitem.id}"]`);
        if (tableRow) {
          let inputQty = tableRow.querySelector('input.quantity');
          inputQty.setAttribute('data-cartid', '');
          inputQty.value = 0;
        }
      }
    });

    // Update

    if (Object.keys(idsToRemove).length == 0) {
      this.initiateOrderSummary();
      return;
    }

    const response = await fetch("/cart/update.js", {
      body: JSON.stringify({ updates: idsToRemove }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    });

    const json = await response.json();

    if (typeof json.items !== 'undefined') {
      this.lineItems = json.items;
    }

    setTimeout(() => {
      this.initiateOrderSummary();
    }, 500);
  }

   /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
   async manageQtyBtn(event) {
    event.preventDefault();

    // Cancel any pending update when a new click is detected
    if (this.updateDebounceTimer) {
      clearTimeout(this.updateDebounceTimer);
    }

    // Setting up the debounced action
    this.updateDebounceTimer = setTimeout(async () => {
      const currentTarget = event.target.closest(".input-group-text");
      console.log("currentTarget", currentTarget);
      const action = currentTarget.dataset.for || "increase";
      const productHandle = currentTarget.closest('[data-product-row]').dataset.productHandle;
      const variantId = currentTarget
        .closest("[data-product-row], .quantity-box")
        .getAttribute("data-variantid");
      const qtyInputEle = document.getElementById(`qtyInput-${variantId}`);
      const currentQty = parseInt(qtyInputEle.value);


      const variantExists = this.arraySummary.some(
        (obj) =>
          obj.variantId ==
          currentTarget
            .closest("[data-variantid]")
            .getAttribute("data-variantid")
      );

      let cartId = qtyInputEle.dataset.cartid;

      let firstLineItemQty;
      let variantTotalQty = qtyInputEle.value;

      if (cartId.includes(',')) {
        cartId = cartId.split(',')[0];
      }

      const arr = cartId.split('-');
      cartId = arr[0];
      firstLineItemQty = parseInt(arr[1]);

      let updatedLineItemQty = firstLineItemQty

      if (action === 'increase') {
        updatedLineItemQty = firstLineItemQty + 1;
        variantTotalQty++;
      } else if (action === 'decrease' && variantTotalQty >= 1 && variantExists) {
        updatedLineItemQty = firstLineItemQty - 1;
        variantTotalQty--;
      }

      qtyInputEle.value = variantTotalQty;

      if (updatedLineItemQty == 0) {
        qtyInputEle.dataset.cartid = qtyInputEle.dataset.cartid.replace(cartId + '-' + firstLineItemQty, '');
      } else {
        qtyInputEle.dataset.cartid = qtyInputEle.dataset.cartid.replace(cartId + '-' + firstLineItemQty, cartId + '-' + updatedLineItemQty).trim(',');
      }

      qtyInputEle.dataset.cartid = qtyInputEle.dataset.cartid.replace(/^[, ]+|[, ]+$/g, '');

       // Example use
      console.log(variantId + "+++++++++" + variantTotalQty);

      if (cartId) {
        try {
          this.lock(cartId);

          await this.updateCart(cartId, updatedLineItemQty);
          console.log("✅ Cart updated successfully for:", updatedLineItemQty);

        } catch (error) {
          console.log(error);
        } finally {
          this.unlock(cartId);
        }
      } else {
        this.lock(variantId);
        await this.addToCart(variantId, qtyInputEle);
        console.log("✅ Item added to cart:", variantId);

      }

      this.checkFreeGifts();
      //this.initiateOrderSummary();
    }, 500); // Wait for 300ms before updating the cart
  }

  async removeProductFromCart(event) {
    event.preventDefault();

    const currentTarget = event.currentTarget;

    const variantId = currentTarget
      .closest(".order-summary-item")
      .getAttribute("data-variantid");

    const qtyInputEle = document.getElementById(`qtyInput-${variantId}`);

    qtyInputEle.value = 0;

    const cartId = qtyInputEle.dataset.cartid;
    let lineItems = [];
    if (cartId.includes(',')) {
      lineItems = cartId.split(',');
    } else {
      lineItems = [cartId];
    }

    for (let i = 0; i < lineItems.length; i++) {
      let lineItemKey = lineItems[i].split('-')[0];

      try {
        this.lock(variantId);
        await this.updateCart(lineItemKey, 0);
      } catch (error) {
        console.log(error);
      } finally {
        this.unlock(variantId);
      }
    }

    qtyInputEle.dataset.cartid = '';
    this.initiateOrderSummary();
  }

  async fetchCart(callback) {
    const response = await fetch("/cart.json");
    const data = await response.json();
    const { items } = data ?? {};
    this.lineItems = items;
    if (callback) {
      callback();
    }
    console.log('--- fetchCart ---', this.lineItems);
  }

  async addToCart(variantId, qtyInputEle) {
    const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      const data = await response.json();
      await this.fetchCart();

      if (qtyInputEle) {
        const cartId = data?.items?.[0]?.key;
        qtyInputEle.setAttribute("data-cartId", `${cartId}-1`);
      }

      this.unlock(variantId);
  }

  updateTableRows() {
    if ( !this.lineItems ) {
      return false;
    }

    let groupedCartIds = {};
    let variantQty = {};

    this.lineItems.forEach(item => {
      if (typeof groupedCartIds[item.variant_id] === 'undefined') {
        groupedCartIds[item.variant_id] = [];
        variantQty[item.variant_id] = 0;
      }

      groupedCartIds[item.variant_id].push({
        key: item.key,
        qty: item.quantity
      });
      variantQty[item.variant_id] += item.quantity;
    });

    for (let variantId in groupedCartIds) {
      let tableRow = document.querySelector(`tr[data-variantid="${variantId}"]`);
      if (!tableRow) {
        console.error(`No table row is found. Variant ID: ${variantId}`);
        return;
      }

      let inputQty = tableRow.querySelector('input.quantity');
      let newCartId = groupedCartIds[variantId].map(obj => obj.key + '-' + obj.qty).join(',');
      inputQty.setAttribute('data-cartid', newCartId);
      inputQty.value = variantQty[variantId];
    }
  }

  updateCart(cartId, quantity) {
    return new Promise((resolve, reject) => {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: cartId,
          quantity: quantity,
        }),
      })
      .then(response => response.json())
      .then(data => {
        this.lineItems = data.items

        // Update data-cartid for each row in the table
        this.updateTableRows();

        this.checkFreeGifts();
        console.log('--- updateCart ---', this.lineItems);
        resolve();
      })
      .catch((error) => reject(error));
    });
  }

  lock(id) {
    this.cartAPIThreads.push(id);
    this.refreshCheckoutBtnStatus();
  }

  unlock(id) {
    this.cartAPIThreads.splice(this.cartAPIThreads.indexOf(id), 1);
    this.refreshCheckoutBtnStatus();
  }

  refreshCheckoutBtnStatus() {
    if (this.cartAPIThreads.length > 0) {
      this.querySelector("[data-add-main-cart]").classList.add("loading");
    } else {
      this.querySelector("[data-add-main-cart]").classList.remove("loading");
    }
  }

  async removeOldItems() {
    try {
      const response = await fetch("/cart.json");
      const data = await response.json();
      const { items } = data ?? {};

      this.lineItems = items;
      console.log('--- removeOldItems ---', this.lineItems);

      for (const item of items || []) {
        const { id, handle } = item ?? {};

        if (id && handle) {
          if (
            handle.includes("-back") ||
            //handle.includes("-10-pack") ||
            //handle.includes("-5-pack") ||
            handle.includes("omnilux-contour-face-providers")
          ) {
            console.log(
              `removing item ${handle} from your cart because the item is no longer available`
            );

            try {
              this.lock(`${id}`);
              await this.updateCart(`${id}`, 0);
            } catch (error) {
              console.log(error);
            } finally {
              this.unlock(`${id}`);
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  checkFreeShippingEligible() {
    fetch(`https://ipapi.co/json/`)
      .then((response) => response.json())
      .then((data) => {
        const continent = data?.continent_code.toLowerCase();
        const country = data?.country_tld.replace(".", "");
        const region = data?.region;

        if (continent === "eu" || ["us", "uk", "ca", "au"].includes(country)) {
          this.freeShippingEligible = true;

          // Block Hawaii, Alaska, and Northern Ireland
          if (
            region === "Alaska" ||
            region === "Hawaii" ||
            region === "Northern Ireland"
          ) {
            this.freeShippingEligible = false;
          }
        } else {
          this.freeShippingEligible = false;
        }

        console.log(continent, country, region, this.freeShippingEligible);
      })
      .catch((error) => {
        console.error(error);
        this.freeShippingEligible = false;
      })
      .finally(() => {
        this.initiateOrderSummary();
      });
  }
}

customElements.define("purchase-form", PurchaseForm);
